import React, { useMemo } from 'react';

import config from '../../config';
import TrackingActions from '../../actions/TrackingActions';
import { translate as t } from '../../lib/I18n';
import Icon from '../general/Icon';

function WebchatLink() {
    const url = useMemo(() => config.get('webchatIframeSrc'), []);

    const handleClick = () => {
        TrackingActions.webchatOpened();
    };

    return (
        <a
            href={url}
            className="navlink__webchat btn"
            aria-label={t('ariaLabel.webchatButton')}
            target="_blank"
            tabIndex="0"
            onClick={handleClick}
        >
            <Icon icon="chat" />
        </a>
    );
}

WebchatLink.propTypes = {};

export default WebchatLink;
